/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { combineReducers, configureStore, Reducer } from '@reduxjs/toolkit'
import { multigetSliceReducer } from 'redux_toolkit/lib/multigetSlice'
import { grpcReducer, grpcReducerNamespace } from 'redux_toolkit/lib/reducer'
import { keyValuesSlice } from 'redux_toolkit/slices/keyValueSlice'
import { optimisticRollupCounts } from 'redux_toolkit/slices/optimisticRollupCounts'
import { pendingActionsSliceV2 } from 'redux_toolkit/slices/pendingActionsSliceV2'

const staticReducers = {
    [grpcReducerNamespace]: grpcReducer,
    keyValues: keyValuesSlice.reducer,
    optimisticRollupCounts: optimisticRollupCounts.reducer,
    multiGet: multigetSliceReducer,
    pendingActionsV2: pendingActionsSliceV2.reducer,
}

const createReducer = (asyncReducers = {}) =>
    combineReducers({
        ...staticReducers,
        ...asyncReducers,
    })

export const store = configureStore({
    reducer: createReducer(),
    devTools: true,
    // middleware: (getDefaultMiddleware) =>
    //     getDefaultMiddleware({
    //         serializableCheck: false, // just for new Errors :-/
    //     }),
})

const asyncReducers: { [key: string]: Reducer } = {}

export const injectReducer = (key: string, reducer: Reducer) => {
    if (!asyncReducers[key]) {
        asyncReducers[key] = reducer
        store.replaceReducer(createReducer(asyncReducers))
    }
}

export type RootState = ReturnType<typeof store.getState>;
